import { Skeleton } from '../ui/skeleton';
import { ScoreGauge } from '../../pages/dashboard/onpage/SEOCharts';

export function ScoreCard({ score, grade, delta, loading = false }) {
  if (loading) {
    return (
      <div className="p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 flex flex-col items-center gap-3">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="w-[160px] h-[100px] rounded-lg" />
        <Skeleton className="h-3 w-16" />
      </div>
    );
  }

  return (
    <div className="p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 flex flex-col items-center">
      <p className="text-xs text-slate-500 mb-1">SEO Health Score</p>
      <ScoreGauge score={score ?? 0} grade={grade ?? 'C'} />
      {delta !== undefined && delta !== null && (
        <span className={`text-xs -mt-1 ${delta >= 0 ? 'text-emerald-600' : 'text-red-500'}`}>
          {delta >= 0 ? '+' : ''}{delta} pts vs prev
        </span>
      )}
    </div>
  );
}
